import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from '../components/helpers/LazyRoute';
import { FormStudent, FormGeneral, TermsOfUse } from '../utils/lazyImports';
import BibliotecaLandingPage from 'pages/BibliotecaLandingPage';
import ConversasTerapeuticasLandingPage from 'pages/ConversasTerapeuticas/ConversasTerapeuticasLandingPage';
import GrupoWhatsAppPage from 'pages/ConversasTerapeuticas/GrupoWhatsAppPage';

export const PublicRoutes = (
  <>
    <Route path="/form-student" element={<LazyRoute><FormStudent /></LazyRoute>} />
    <Route path="/form-general" element={<LazyRoute><FormGeneral /></LazyRoute>}/>
    <Route path="/terms-of-use" element={<LazyRoute><TermsOfUse /></LazyRoute>}/>
    <Route path="/biblioteca" element={<BibliotecaLandingPage />} />
    <Route path="/conversas-terapeuticas" element={<ConversasTerapeuticasLandingPage />} />
    <Route path="/grupo-whatsapp" element={<GrupoWhatsAppPage />} />
  </>
);
